module.exports = __webpack_public_path__ + "a766eb9b0fb1ccaa2b9f3480390b205c.png";